import { useTranslation } from "react-i18next";
import { useDeleteSchema } from "@noa/api-client";
import type { DocumentTypeSchema } from "@noa/api-core";
import { schemaDialogProps } from "~/utils/schema-admin";
import { Dialog, message, Paragraph, Text } from "~/components/ui";

type SchemaDeleteModalProps = {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  schema: DocumentTypeSchema | null;
};

export function SchemaDeleteModal({ isOpen, setIsOpen, schema }: SchemaDeleteModalProps) {
  const { t } = useTranslation("admin");
  const { mutate: deleteSchema, isPending } = useDeleteSchema();

  const handleConfirm = () => {
    if (!schema) return;

    deleteSchema(schema.schema_id, {
      onSuccess: () => {
        message.success(t("schemaAdmin.messages.deleted"));
        setIsOpen(false);
      },
      onError: () => {
        message.error(t("schemaAdmin.messages.deleteError"));
      },
    });
  };

  return (
    <Dialog
      title={t("schemaAdmin.modal.deleteTitle")}
      open={isOpen}
      onOk={handleConfirm}
      onCancel={() => setIsOpen(false)}
      okText={t("schemaAdmin.actions.delete")}
      okButtonProps={{ danger: true }}
      cancelText={t("common:cancel")}
      confirmLoading={isPending}
      {...schemaDialogProps}
    >
      <Paragraph>
        {t("schemaAdmin.modal.deleteConfirm")} <Text strong>{schema?.schema_id}</Text>?
      </Paragraph>
      <Text tone="muted">{t("schemaAdmin.modal.deleteWarning")}</Text>
    </Dialog>
  );
}
